/* eslint-disable no-param-reassign */
const GTM = require('../datalayer');
const gtmUtils = require('../utils');

const selectOptionClicked = () => {
    let selectedOption = {};
    if ($('.custom-select').length) {
        $('body').on('change', 'select', (e) => {
            if ($(e.target).attr('id') !== 'state') {
                const targetLabel = $(e.target).parent().find('label')[0] ? $(e.target).parent().find('label')[0].innerText : '';
                selectedOption = {
                    elementTarget: $(e.currentTarget)[0].selectedOptions[0].outerHTML,
                    labelText: targetLabel,
                };

                GTM.trackEventOption('click', selectedOption);
            }
        });
    }
};

const infoAddToCart = () => {
    $('body').on(
        'click',
        'button.add-to-cart, button.add-to-cart-global, button.add-to-cart-globalGrid',
        (e) => {
            const target = $(e.currentTarget);
            const productId = target.closest('.product-detail:not(.product-detail-set)')
                .find('.product-id')
                .text();
            const prodViewData = $('.prodviewData');
            const dataString = prodViewData.val();

            if (!target.hasClass('disabled') && (prodViewData.length && dataString !== 'null')) {
                const data = JSON.parse(prodViewData.val());
                const cartInfo = {
                    currency: data.mainProduct.currency,
                    product: data.mainProduct.product,
                    mainProduct: data.mainProduct.mainProduct,
                };
                // eslint-disable-next-line prefer-const
                let productToAdd = { product: [], currency: '' };

                if (cartInfo.mainProduct.groupProductsId === productId
                        || cartInfo.product[0].variations) {
                    // will add only one product
                    cartInfo.product.forEach((value, index) => {
                        const isProductVariation = 'sku' in value;
                        const prodIDtoCompare = isProductVariation ? value.sku : value.id;

                        if (prodIDtoCompare === productId) {
                            if (isProductVariation) {
                                value.id = value.sku;
                                delete value.sku;
                            }

                            productToAdd.currencyCode = cartInfo.currency;
                            productToAdd.product.push(value);

                            if ('position' in value) {
                                delete productToAdd.product.position;
                            }

                            productToAdd.product[0].quantity = $('.quantity')
                                .eq(index)
                                .val();
                        }
                    });
                } else {
                    // will add a group of products (product set or bundle)
                    cartInfo.product.forEach((product) => {
                        cartInfo.mainProduct.mainProductsId.forEach(
                            (groupId, index) => {
                                // eslint-disable-next-line no-undef
                                if (product.id === groupId) {
                                    productToAdd.product.push(product);
                                    delete productToAdd.product[index].position;
                                    productToAdd.product[index].quantity = $(
                                        '.quantity',
                                    ).val();
                                }
                            },
                        );
                    });
                    productToAdd.currencyCode = cartInfo.currency;
                }

                GTM.trackAddProductToCart(productToAdd, gtmUtils.getList());
            }
        },
    );
};

const infoProductsReady = () => {
    const prodViewData = $('.prodviewData');

    if (prodViewData.length && prodViewData.val() !== 'null') {
        const data = JSON.parse(prodViewData.val());
        const prodInfo = {
            currency: data.mainProduct.currency,
            product: data.mainProduct.product,
        };

        GTM.trackProductDetail(prodInfo);

        if (data.recommendedProducts.length) {
            const recommendedProdInfo = {
                currency: data.mainProduct.currency,
                product: data.recommendedProducts,
            };

            GTM.trackProductImpression(recommendedProdInfo);
        }
    }
};

const productClicked = () => {
    const product = [];

    $('body').on(
        'click',
        '.product-tile > .image-container > a:not(.wishlistTile):not(.quickview), .product-tile > .tile-body > .pdp-link > a.product-name',
        (e) => {
            e.preventDefault();
            const productDiv = $($(e.currentTarget).parents('.product'));
            const productUrl = productDiv.find('.pdp-link > a')[0].href;

            product.push(gtmUtils.productClickStructure(productDiv));

            GTM.trackClickedProduct('productClick', {
                product,
                list: gtmUtils.getList(productDiv),
                productUrl,
            });
        },
    );
};

const updateProdVariation = () => {
    $('body').on('seo:updateProductVariant', (e, responseProduct) => {
        const productObectDatalayer = $('.prodviewData');

        // update datalayer of input hidden (Ex:used for add to card actions)
        if (productObectDatalayer.length && productObectDatalayer.val() !== 'null') {
            const ismlDatalayerObj = JSON.parse(productObectDatalayer.val());
            // eslint-disable-next-line max-len
            ismlDatalayerObj.mainProduct.product[0].variant = responseProduct.variations;
            ismlDatalayerObj.mainProduct.product[0].price = responseProduct.price;
            ismlDatalayerObj.mainProduct.product[0].name = responseProduct.name;

            if (
                (responseProduct.id
                    !== ismlDatalayerObj.mainProduct.product[0].id
                ) && (responseProduct.variant !== '')
            ) {
                // eslint-disable-next-line max-len
                ismlDatalayerObj.mainProduct.product[0].sku = responseProduct.id;
            }

            productObectDatalayer.val(JSON.stringify(ismlDatalayerObj));

            // trigger for update datalayer variation
            GTM.updateTrackProductDetail(ismlDatalayerObj.mainProduct.product);
        }
    });
};

export default () => {
    selectOptionClicked();
    infoAddToCart();
    infoProductsReady();
    productClicked();
    updateProdVariation();
};
